import ProfileForm from './ProfileForm'

export default ProfileForm



// WEBPACK FOOTER //
// ./src/views/Settings/components/ProfileForm/index.js